import { render, staticRenderFns } from "./mb_detail.vue?vue&type=template&id=b1dd6c00&scoped=true&"
import script from "./mb_detail.vue?vue&type=script&lang=js&"
export * from "./mb_detail.vue?vue&type=script&lang=js&"
import style0 from "./mb_detail.vue?vue&type=style&index=0&id=b1dd6c00&prod&scoped=true&lang=css&"
import style1 from "./mb_detail.vue?vue&type=style&index=1&id=b1dd6c00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dd6c00",
  null
  
)

export default component.exports